import React, { useContext, useEffect, useState } from "react";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOnGetAccountsByDateReportDTO from "../../../../models/DTO/IOnGetAccountsByDateReportDTO";
import IOwDivTableCols from "../../../shared/OwDivTable/IOwDivTableCols";
import IOnGetSerialsInOrdersReportDTO from "../../../../models/DTO/IOnGetSerialsInOrdersReportDTO";
import IOwTableCols from "../../../../models/IOwTableCols";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { OwDivTable } from "../../../shared/OwDivTable/OwDivTable";
import ISerialsInOrdersItem from "../../../../models/ISerialsInOrderItem";
import ExcelJS from "exceljs/dist/exceljs.min.js";
import moment from "moment-timezone";

type Props = {
    processedReport: IProcessed_Report;
};

export const SerialsInOrdersReport = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const renderOrderNo = (row: ISerialsInOrdersItem) => {
        return <div>{row.orderNumber}</div>;
    };

    const renderAccountName = (row: ISerialsInOrdersItem) => {
        return <div>{row.accountName}</div>;
    };

    const renderSerial = (row: ISerialsInOrdersItem) => {
        return <div>{row.serial}</div>;
    };

    const renderClientName = (row: ISerialsInOrdersItem) => {
        return <div>{row.clientName}</div>;
    };

    const renderDescription = (row: ISerialsInOrdersItem) => {
        return <div>{row.description}</div>;
    };

    const getTableCols = (): IOwDivTableCols[] => {
        return [
            {
                title: "order_no",
                renderFn: renderOrderNo,
                className: "w-20",
            },
            {
                title: "account",
                renderFn: renderAccountName,
                className: "w-20",
            },
            {
                title: "serial",
                renderFn: renderSerial,
                className: "w-20",
            },
            {
                title: "client",
                renderFn: renderClientName,
                className: "w-20",
            },
            {
                title: "description",
                renderFn: renderDescription,
                className: "w-20",
            },
        ];
    };

    const onGetSerialsInOrdersReportDTO = (data: IOnGetSerialsInOrdersReportDTO) => {
        setReportData(data);
    };

    const downloadExcel = () => {
        if (reportData) {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet("Serials In Orders");

            const salesPeopleWs: { salesperson: string; ws: ExcelJS.Worksheet }[] = [];

            const columns: (
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
            )[] = [
                { header: "Order", key: "orderNo" },
                { header: "Account", key: "account" },
                { header: "Serial", key: "serial" },
                { header: "Client", key: "client" },
                { header: "Description", key: "description" },
            ];

            ws.columns = columns;

            ws.getCell("A1").font = {
                bold: true,
            };

            ws.getCell("B1").font = {
                bold: true,
            };

            ws.getCell("C1").font = {
                bold: true,
            };

            ws.getCell("D1").font = {
                bold: true,
            };

            ws.getCell("E1").font = {
                bold: true,
            };

            for (const order of reportData.orders) {
                const orderNo = order.orderNumber;
                const account = order.accountName;
                const serial = order.serial;
                const client = order.clientName;
                const description = order.description;

                ws.addRow({ orderNo, account, serial, client, description });
            }

            // const periodStart = moment(reportData.periodStart).format("YYYY-MM-DD");
            // const periodEnd = moment(reportData.periodEnd).format("YYYY-MM-DD");

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `orderwerks-serials-in-orders.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    const [reportData, setReportData] = useState<IOnGetSerialsInOrdersReportDTO>();
    const [tableCols, setTableCols] = useState<IOwDivTableCols[]>(getTableCols());

    useEffect(() => {
        onGetSerialsInOrdersReportDTO(props.processedReport.report_data);
    }, []);

    return (
        <div className={"SerialsInOrdersReport"}>
            {reportData && reportData.orders.length > 0 ? <OwButton title={"export_to_excel"} fn={downloadExcel} /> : null}
            <div>
                <OwLabel title={"total_records"} postText={":"} isBold={true} className={"me-2 mb-2 mt-2"} />
                {reportData?.orders.length}
            </div>

            <div className={"mb-5"}>
                <OwDivTable cols={tableCols} data={reportData?.orders || []} />
            </div>
        </div>
    );
};
